import { Breadcrumb as ChakraBreadcrumb } from '@chakra-ui/react';
import { GetIcon } from '../../components/icons';
import { BreadcrumbItem } from './BreadcrumbItem';
import { BreadcrumbLink } from './BreadcrumbLink';
import type { BreadcrumbsItemsList } from './types';

export type BreadcrumbProps = {
    itemsList: BreadcrumbsItemsList[];
};

export const Breadcrumb = ({ itemsList }: BreadcrumbProps): JSX.Element | null =>
    itemsList.length > 0 ? (
        <ChakraBreadcrumb
            data-testid="breadcrumb"
            separator={<GetIcon name="navigation-arrow-right" size="sm" disableHover />}
            spacing={0}
        >
            {itemsList.map((breadcrumbItem) => (
                <BreadcrumbItem key={breadcrumbItem.href}>
                    <BreadcrumbLink href={breadcrumbItem.href}>
                        {breadcrumbItem.label}
                    </BreadcrumbLink>
                </BreadcrumbItem>
            ))}
        </ChakraBreadcrumb>
    ) : null;
